import React, { ChangeEvent, FocusEvent } from 'react';
import { FormField } from './FormField';
import { formatPhoneNumber, formatTaxId, formatRoutingNumber } from '../../utils/onboardingValidation';
import styles from './FormInput.module.css';

interface FormInputProps {
  label: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: (value: string) => void;
  placeholder?: string;
  type?: 'text' | 'email' | 'tel' | 'password' | 'number';
  required?: boolean;
  error?: string;
  helperText?: string;
  disabled?: boolean;
  autoComplete?: string;
  formatType?: 'phone' | 'taxId' | 'routingNumber' | 'none';
  className?: string;
  maxLength?: number;
}

export const FormInput: React.FC<FormInputProps> = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  type = 'text',
  required = false,
  error,
  helperText,
  disabled = false,
  autoComplete,
  formatType = 'none',
  className = '',
  maxLength,
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    let newValue = e.target.value;

    // Apply formatting based on field type
    if (formatType === 'phone') {
      newValue = formatPhoneNumber(newValue);
    } else if (formatType === 'taxId') {
      newValue = formatTaxId(newValue);
    } else if (formatType === 'routingNumber') {
      newValue = formatRoutingNumber(newValue);
    }

    onChange(newValue);
  };

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    if (onBlur) {
      onBlur(e.target.value);
    }
  };

  const isInvalid = !!error;

  return (
    <FormField
      label={label}
      required={required}
      error={error}
      helperText={helperText}
      className={className}
    >
      <input
        type={type}
        name={name}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        autoComplete={autoComplete}
        maxLength={maxLength}
        className={`${styles.input} ${isInvalid ? styles.error : ''} ${className}`}
      />
    </FormField>
  );
};
